import { render, staticRenderFns } from "./onlineUsersList.vue?vue&type=template&id=90570032&scoped=true&"
import script from "./onlineUsersList.vue?vue&type=script&lang=js&"
export * from "./onlineUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90570032",
  null
  
)

export default component.exports